import React from "react";
import { useAuth } from "./AuthContext";
import "./Login.css";

export default function PermissionDenied() {
  const { user, signOut } = useAuth();

  return (
    <div className="permission-denied-screen">
      <div className="permission-denied-card">
        <h1 className="permission-denied-title">Permission denied</h1>
        <p className="permission-denied-message">
          Your account does not have access to this content. If you believe this is an error, please contact the administrator.
        </p>
        {user?.email && (
          <p className="permission-denied-email">Signed in as: {user.email}</p>
        )}
        <button type="button" className="permission-denied-btn" onClick={signOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
